//@flow

import {deleteStoreContact, saveGeneralContact} from './api';
import {buildRoute} from '../../../http';

import {endpoints} from './api';
import type {SaveGeneralContactRequest} from './api';

export function deleteStoreContactService(
  storeContactId: string
): Promise<void> {
  const route = buildRoute(endpoints.DELETE_STORE_CONTACT, [storeContactId]);

  return deleteStoreContact({route}).toPromise();
}

export function createStoreContactService(
  contact: SaveGeneralContactRequest
): Promise<void> {
  return saveGeneralContact(contact).toPromise();
}
